"use client";
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { setLoaderFunctions } from '@/utils/loaderUtils'; // Adjust the import path as needed
import Loader from '@/components/shared/loader';

type LoaderProviderProps = {
    children: ReactNode;
  };
  
  const LoaderContext = createContext({
    showLoader: () => {},
    hideLoader: () => {},
  });
  
  export const useLoader = () => useContext(LoaderContext);
  
  export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
  
    useEffect(() => {
      setLoaderFunctions(showLoader, hideLoader);
    }, []);
  
    useEffect(() => {
      if (loading) {
        setVisible(true);
      } else {
        const timer = setTimeout(() => {
          setVisible(false);
        }, 300); // Delay for smooth transition out
        return () => clearTimeout(timer);
      }
    }, [loading]);
  
    const showLoader = () => setLoading(true);
    const hideLoader = () => setLoading(false);
  
    return (
      <LoaderContext.Provider value={{ showLoader, hideLoader }}>
        {children}
        {visible && (
          <div className="xloader-container"> {/* Apply global CSS class directly */}
            <Loader /> {/* Loader component */}
          </div>
        )}
      </LoaderContext.Provider>
    );
  };